
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip1)","fill":"#545C69"}},[_c('path',{attrs:{"d":"M0 0h3.249v25.047H0zM7.031 0h3.249v25.047H7.031zM16.423 0h3.249v25.047h-3.249zM12.938 0h1.772v25.047h-1.772zM20.381 0h1.713v25.047h-1.713zM23.333 0h1.181v25.047h-1.181zM26.229 0h.65v25.047h-.65zM29.537 0h.65v25.047h-.65zM30.776 0h3.131v25.047h-3.131zM3.84 0h1.477v25.047H3.84zM11.52 0h.827v25.047h-.827z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip1"}},[_c('rect',{attrs:{"width":"32","height":"20","rx":"4","fill":"#fff"}})])])])
          )
        }
      }
    